import { PropsWithChildren } from 'react';

import { Box } from '@chakra-ui/react';

import { DiscountCardHeader, DiscountCardHeaderProps } from './discount-card-header';

export type DiscountCardLayoutProps = PropsWithChildren<{
  headerProps: DiscountCardHeaderProps;
  contentMaxWidth?: string;
}>;

export function DiscountCardLayout({ headerProps, contentMaxWidth = '460px', children }: DiscountCardLayoutProps) {
  return (
    <Box paddingX={{ base: '16px', md: '0px' }}>
      <Box
        bg='white'
        border='1px solid'
        borderColor='grey.100'
        borderRadius='12px'
        margin='0 auto'
        maxWidth='680px'
        overflow='hidden'
        width='100%'
        padding={{
          base: '0px 0px 64px',
          md: '12px 12px 64px',
        }}
      >
        <DiscountCardHeader {...headerProps} />
        <Box margin='0 auto' maxWidth={contentMaxWidth} paddingTop='40px' paddingX={{ base: '16px', md: '0px' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
